import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
/**
 * Displays the quantity of an item with responsive typography based on screen size.
 *
 * @param {number} quantity - The quantity of the item to display.
 */
export const QuantityDisplay = ({ quantity }) => {
    const theme = useTheme();
    return _jsx(Typography, Object.assign({ sx: { color: theme.palette.grey[700] } }, { children: `${quantity}x` }));
};
